import { spacing3 } from '@leaftrade/leaftrade-component-library';
import styled from 'styled-components';

export const ProductDetailsAttachmentDropdownWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing3};
`;
